/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import {WealthyEnv} from "helpers";

const navLinks = [
  {
    url: `${WealthyEnv.URL}`,
    pathname: "/for-investors",
    text: "INVESTORS",
    loginUrl: `${WealthyEnv.APP_URL}`,
    downloadUrl: `${WealthyEnv.APP_DOWNLOAD_ONE_LINK}`,
    adjacentLink: {
      url: `${WealthyEnv.URL}/partner`,
      text: "JOIN AS PARTNER"
    },
    subLinks: [
      {
        text: "INVEST",
        dropdownLinks: [
          {
            url: `${WealthyEnv.APP_URL}/tax-saver`,
            text: "Tax Saver",
            pathname: "/tax-saver"
          },
          {
            url: `${WealthyEnv.APP_URL}/investment-planning`,
            text: "Diversified Portfolios"
          },
          {
            url: `${WealthyEnv.APP_URL}/smart-switch`,
            text: "Smart Switch"
          }
        ]
      },
      {
        url: `${WealthyEnv.URL}/tracker`,
        text: "TRACKER"
      },
      {
        text: "LEARN",
        dropdownLinks: [
          {
            url: `${WealthyEnv.URL}/insights`,
            text: "Insights"
          },
          {
            url: `${WealthyEnv.URL}/money-order`,
            text: "Money Order"
          },
          {
            url: `${WealthyEnv.URL}/stories`,
            text: "Stories"
          },
          {
            url: `${WealthyEnv.URL}/big-picture`,
            text: "Big Picture"
          }
        ]
      },
      {
        url: `${WealthyEnv.URL}/about-us`,
        text: "ABOUT US"
      }
    ]
  },
  // {
  //   url: `${WealthyEnv.URL}/partner`,
  //   pathname: "/partner",
  //   text: "PARTNERS",
  //   loginUrl: WealthyEnv.BUILDWEALTH_APP_URL,
  //   downloadUrl: `${WealthyEnv.WEALTHY_PARTNERS_APP_LINK}`,
  //   adjacentLink: {
  //     url: `${WealthyEnv.URL}/investors`,
  //     text: "FOR INVESTORS"
  //   },
  //   subLinks: [
  //     // {
  //     //   url: `${WealthyEnv.URL}/events/mera-business`,
  //     //   text: "EVENTS",
  //     //   pathname: "/events/mera-business"
  //     // },
  //     {
  //       url: `${WealthyEnv.URL}/about-us`,
  //       text: "ABOUT US",
  //       pathname: "/about-us"
  //     }
  //   ]
  // },
  {
    url: `${WealthyEnv.URL}/partner`,
    pathname: "/partner",
    text: "PARTNER",
    loginUrlFromPartners: WealthyEnv.BUILDWEALTH_APP_URL,
    adjacentLink: {
      url: `${WealthyEnv.URL}/partner-blog`,
      text: "Blog"
    }
  },
  {
    url: `${WealthyEnv.URL}/partner-blog`,
    pathname: "/partner-blog",
    text: "PARTNER-BLOG",
    loginUrlFromPartners: WealthyEnv.BUILDWEALTH_APP_URL
  },
  {
    url: `${WealthyEnv.URL}/mutual-fund-distributor`,
    pathname: "/mutual-fund-distributor",
    text: "Mutual Fund Distributor",
    loginUrlFromPartners: WealthyEnv.BUILDWEALTH_APP_URL
  },
  {
    url: `${WealthyEnv.URL}`,
    pathname: "/",
    text: "Clients",
    loginUrlFromPartners: WealthyEnv.APP_URL,
    isNewInvestorsPage: true,

    subLinks: [
      {
        url: `${WealthyEnv.URL}/broking`,
        text: "Broking",
        style: {color: "#000000", fontFamily: "Avenir-Book", fontSize: "1.4rem"}
      },
      {
        url: `${WealthyEnv.URL}/pricing`,
        text: "Pricing",
        style: {color: "#000000", fontFamily: "Avenir-Book", fontSize: "1.4rem"}
      },
      {
        url: `${WealthyEnv.URL}/invest/stocks`,
        text: "Invest",
        style: {color: "#000000", fontFamily: "Avenir-Book", fontSize: "1.4rem"}
      },
      {
        text: "Learn",
        style: {color: "#000000", fontFamily: "Avenir-Book", fontSize: "1.4rem"},
        dropdownLinks: [
          {
            url: `${WealthyEnv.URL}/blogs`,
            text: "Blogs",
            style: {color: "#000000", fontFamily: "Avenir-Book", fontSize: "1.4rem"}
          },
          {
            url: `${WealthyEnv.URL}/newsletter`,
            text: "Newsletter",
            style: {color: "#000000", fontFamily: "Avenir-Book", fontSize: "1.4rem"}
          }
        ]
      },
      {
        url: `${WealthyEnv.URL}/partner`,
        text: "For partners",
        pathname: "/partner",
        style: {color: "#6725F4", fontFamily: "Avenir-Book", fontSize: "1.4rem"}
      },
      {
        url: `${WealthyEnv.URL}/nri-investment-options-india/`,
        text: "For NRIs",
        pathname: "/nri-investment-options-india/",
        style: {color: "#6725F4", fontFamily: "Avenir-Book", fontSize: "1.4rem"}
      }
    ]
  },
  {
    url: `${WealthyEnv.URL}`,
    pathname: "/about-us",
    text: "Clients",
    loginUrlFromPartners: WealthyEnv.APP_URL,
    isNewInvestorsPage: true,

    subLinks: [
      {
        url: `${WealthyEnv.URL}/broking`,
        text: "Broking",
        style: {color: "#000000", fontFamily: "Avenir-Book", fontSize: "1.4rem"}
      },
      {
        url: `${WealthyEnv.URL}/pricing`,
        text: "Pricing",
        style: {color: "#000000", fontFamily: "Avenir-Book", fontSize: "1.4rem"}
      },
      {
        url: `${WealthyEnv.URL}/invest/stocks`,
        text: "Invest",
        style: {color: "#000000", fontFamily: "Avenir-Book", fontSize: "1.4rem"}
      },
      {
        text: "Learn",
        style: {color: "#000000", fontFamily: "Avenir-Book", fontSize: "1.4rem"},
        dropdownLinks: [
          {
            url: `${WealthyEnv.URL}/blogs`,
            text: "Blogs",
            style: {color: "#000000", fontFamily: "Avenir-Book", fontSize: "1.4rem"}
          },
          {
            url: `${WealthyEnv.URL}/newsletter`,
            text: "Newsletter",
            style: {color: "#000000", fontFamily: "Avenir-Book", fontSize: "1.4rem"}
          }
        ]
      },
      {
        url: `${WealthyEnv.URL}/partner`,
        text: "For partners",
        pathname: "/partner",
        style: {color: "#6725F4", fontFamily: "Avenir-Book", fontSize: "1.4rem"}
      },
      {
        url: `${WealthyEnv.URL}/nri-investment-options-india/`,
        text: "For NRIs",
        pathname: "/nri-investment-options-india/",
        style: {color: "#6725F4", fontFamily: "Avenir-Book", fontSize: "1.4rem"}
      }
    ]
  },
  {
    url: `${WealthyEnv.URL}/private-wealth-partner`,
    pathname: "/private-wealth-partner",
    text: "Private Wealth Partner",

    subLinks: [
      {
        url: `${WealthyEnv.URL}/about-us`,
        text: "About Us",
        pathname: "/about-us",
        style: {marginLeft: "-20rem"}
      },
      {
        url: `${WealthyEnv.URL}`,
        text: "For clients",
        pathname: "/",
        style: {color: "#ff9899", marginLeft: "-10rem"}
      }
    ]
  }
];

export default navLinks;
